module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/target03-e11577554dabec3f4a5fcf7e55653c48.png";